<script setup lang="ts">
import { definePage } from "unplugin-vue-router/runtime";
import OrthoPCCompanyAddEditForm from "@/components/models/company/forms/OrthoPCCompanyAddEditForm.vue";
import { useRoute } from "vue-router";
import { computed } from "vue";
import { useCompany } from "@/composables/models/company/useCompany";
import { useAbility } from "@casl/vue";

definePage({
  meta: {
    title: "generic.action.editEntity",
    titleParams: { entity: "generic.entity.orthoPcCompany" },
    checkPrivileges: () => {
      const { can } = useAbility();
      return can($permActions.UPDATE, $permSubjects.PRACTICE__COMPANY);
    },
  },
});

const route = useRoute();
const orthoPCCompanyId = computed(() => (route.params as { id: string }).id);
const { data: defaultValues, isLoading } = useCompany({ id: orthoPCCompanyId });
</script>

<template>
  <v-skeleton-loader :loading="isLoading">
    <ortho-p-c-company-add-edit-form :defaultValues="defaultValues" />
  </v-skeleton-loader>
</template>

<style scoped></style>
